import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPoorHealth = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "poorHealth",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12671",
			"data-name": "Path 12671",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12672",
			"data-name": "Path 12672",
			d: "M12,4.925A5.343,5.343,0,0,1,16.158,3c3.571,0,5.967,3.352,5.967,6.474C22.125,16,14,21,12,21S1.875,16,1.875,9.474C1.875,6.352,4.271,3,7.842,3A5.343,5.343,0,0,1,12,4.925Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12673",
			"data-name": "Path 12673",
			d: "M7,11.5H9.222L10.889,9l2.222,5,1.667-2.5H17",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgPoorHealth;
